import datasreen from './datascreen.json';

export default { ...datasreen };
